import React from 'react'
import { Link } from "react-router-dom"
import { ProgressBar } from 'react-bootstrap'
import "./Card.scss"

const Card = ({ nombre, usuario, fecha, estado, progreso = 0, link}) => {
  return (
    <Link to={link} className='card d-flex flex-column justify-content-between p-3 rounded-3 border border-light-subtle'>
        <div className='mb-3 d-flex flex-row align-items-start justify-content-between'>
            <div className='d-flex flex-column'>
                <span className='fw-semibold text-secondary p-0 m-0 mb-1'>PROYECTO</span>
                <p className='p-0 m-0'>{nombre}</p>
            </div>
            {estado === 1 && <div className='estado-pill d-flex align-items-center justify-content-center px-2 py-1 rounded-pill text-white text-center fw-medium bg-warning'><span className='p-0 m-0'>En espera</span></div>}
            {estado === 2 && <div className='estado-pill d-flex align-items-center justify-content-center px-2 py-1 rounded-pill text-white text-center fw-medium bg-danger'><span className='p-0 m-0'>Rechazado</span></div>}
            {estado === 3 && <div className='estado-pill d-flex align-items-center justify-content-center px-2 py-1 rounded-pill text-white text-center fw-medium bg-success'><span className='p-0 m-0'>Aceptado</span></div>}
        </div>
        <div className='d-flex flex-column'>
            <div className='mb-3 d-flex flex-row align-items-start justify-content-between'>
                <div className='d-flex flex-column'>
                    <span className='fw-semibold text-secondary p-0 m-0 mb-1'>CREADO POR</span>
                    <p className='d-flex flex-row align-items-start p-0 m-0'><i className="bi bi-person-circle me-1 text-blue-500"></i>{usuario}</p>
                </div>
                <div className='d-flex flex-column'>
                    <span className='fw-semibold text-secondary p-0 m-0 mb-1'>FECHA</span>
                    <p className='d-flex flex-row align-items-center p-0 m-0'><i className="bi bi-calendar-event me-1 text-blue-500"></i>{fecha}</p>
                </div>
            </div>
            <div className='d-flex flex-column'>
                <ProgressBar className='mb-1' now={Math.round(progreso)} max={100} />
                <div className='d-flex flex-row align-items-center justify-content-between'>
                    <span className='fw-semibold text-secondary p-0 m-0'>PROGRESO</span>
                    <span className='p-0 m-0 fw-semibold text-blue-500'>{progreso}%</span>
                </div>
            </div>
        </div>
    </Link>
  )
}

export default Card